import React from "react";
import {
  BsPerson,
  BsListCheck,
  BsClockHistory
  , BsJournalText
} from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";

function BottomNavbar() {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { path: "/dashboard", label: "Presensi", icon: <BsListCheck size={20} /> },
    { path: "/riwayat", label: "Riwayat", icon: <BsClockHistory size={20} /> },
    { path: "/jurnal", label: "Jurnal", icon: <BsJournalText size={20} /> },
    { path: "/akun", label: "Akun", icon: <BsPerson size={20} /> },
  ];

  return (
    <nav className="position-fixed bottom-0 start-0 end-0 bg-white border-top d-flex justify-content-around py-2">
      {navItems.map((item) => {
        const isActive = location.pathname === item.path;
        return (
          <div
            key={item.path}
            className={`text-center ${isActive ? "" : "text-muted"}`}
            style={{ cursor: "pointer" }}
            onClick={() => navigate(item.path)}
          >
            {item.icon}
            <div className={`small ${isActive ? "fw-bold" : ""}`}>{item.label}</div>
          </div>
        );
      })}
    </nav>
  );
}

export default BottomNavbar;
